// extracted by mini-css-extract-plugin
module.exports = {"first":"Chart1_first__35OA7","second":"Chart1_second__3sw9q","third":"Chart1_third__5Mm6W"};